import { atom } from "recoil";
import { Dashboard, DashboardQuery } from "../types/files";

const dashboardsLoadedState = atom({
  key: 'dashboards/dashboardsLoaded',
  default: false,
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['dashboards/dashboardsLoaded', newValue]);
    });
  }],
});

const dashboardsState = atom<Dashboard[]>({
  key: 'dashboards/dashboards',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['dashboards/dashboards', newValue]);
    });
  }],
});

const externalDashboardsState = atom<Dashboard[]>({
  key: 'dashboards/externalDashboards',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['dashboards/externalDashboards', newValue]);
    });
  }],
});

const groupDashboardQueriesState = atom<DashboardQuery[]>({
  key: 'dashboards/groupDashboardQueries',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['dashboards/groupDashboardQueries', newValue]);
    });
  }],
});

const externalDashboardQueriesState = atom<DashboardQuery[]>({
  key: 'dashboards/externalDashboardQueries',
  default: [],
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['dashboards/externalDashboardQueries', newValue]);
    });
  }],
});

const isPublicViewState = atom<boolean>({
  key: 'dashboards/isPublicView',
  default: false,
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['dashboards/isPublicView', newValue]);
    });
  }],
});

const isSharedState = atom<boolean>({
  key: 'dashboards/isShared',
  default: false,
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['dashboards/isShared', newValue]);
    });
  }],
});

export {
  dashboardsLoadedState,
  dashboardsState,
  externalDashboardsState,
  groupDashboardQueriesState,
  externalDashboardQueriesState,
  isPublicViewState,
  isSharedState,
};